import { Box, Stack } from '@mui/material';
import InsuranceSwitch from './Insurance/InsuranceSwitch';
import InsuranceLevel from './Insurance/InsuranceLevel';
import InsuranceDuration from './Insurance/InsuranceDuration';
import InsuranceCostEstimation from './Insurance/InsuranceCostEstimation';
import { FC } from 'react';

interface Props {
	fee: string
}

const FuturesBotInsuranceSettings: FC<Props> = ({ fee }) => {
	return (
		<Stack spacing={1} sx={{ paddingTop: 2 }}>
			<InsuranceSwitch />
			<InsuranceLevel />
			<InsuranceDuration />
			<InsuranceCostEstimation fee={fee} />
    </Stack>
	);
};

export default FuturesBotInsuranceSettings;